import { ICONS } from 'labstep-web/constants/icons';
import { Card } from 'labstep-web/core/Card/Card';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { EntityRelationType } from 'labstep-web/models/field-definition.model';
import type { SemanticICONS } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { FieldDefinitionFormLinkTypePreviewProps } from './types';

export const FieldDefinitionFormLinkTypePreview: React.FC<
  FieldDefinitionFormLinkTypePreviewProps
> = ({
  entityName,
  relationType,
  relationName = '',
  backLinkName = '',
  categoryNameA,
  categoryNameB,
  label = 'Preview',
  resourceNameA,
  resourceNameB,
}) => {
  const backlink =
    backLinkName !== '' ? backLinkName : 'Inverse Field Name';
  const relation = relationName !== '' ? relationName : 'Field Name';

  const displayNameA = resourceNameA || `${entityName} A`;
  const displayNameB = resourceNameB || `${entityName} B`;

  return (
    <Flex column spacing="gap">
      {label}
      <Flex
        vAlignContent="center"
        hAlignContent="center"
        spacing="gap"
      >
        <Card className={styles.preview}>
          <Flex column spacing="gap">
            {categoryNameA && (
              <Flex
                vAlignContent="center"
                className={styles.category}
              >
                <Icon name="box" size="small" />
                <span>{categoryNameA}</span>
                <Icon name="chevron right" size="small" />
              </Flex>
            )}
            <Flex>
              <Icon
                name={ICONS.resource.primary as SemanticICONS}
                size="large"
              />
              <span className={styles.name}>{displayNameA}</span>
            </Flex>
            <Flex
              style={{ alignItems: 'baseline', marginLeft: '4px' }}
            >
              <Icon
                name={ICONS.metadata.secondary as SemanticICONS}
                size="small"
                color="grey"
              />
              <span
                className={styles.relation}
                data-testid="relationName"
              >
                {relation} :
              </span>
              <span className={styles.subname}>
                <Icon
                  name={ICONS.resource.primary as SemanticICONS}
                  size="small"
                />
                {displayNameB}
              </span>
            </Flex>
          </Flex>
        </Card>
        <Card className={styles.preview}>
          <Flex column spacing="gap">
            {categoryNameB && (
              <Flex
                vAlignContent="center"
                className={styles.category}
              >
                <Icon name="box" size="small" />
                <span>{categoryNameB}</span>
                <Icon name="chevron right" size="small" />
              </Flex>
            )}
            <Flex>
              <Icon
                name={ICONS.resource.primary as SemanticICONS}
                size="large"
              />
              <span className={styles.name}>{displayNameB}</span>
            </Flex>
            {relationType !== EntityRelationType.one_way && (
              <Flex
                style={{ alignItems: 'baseline', marginLeft: '4px' }}
              >
                <Icon
                  name={ICONS.metadata.secondary as SemanticICONS}
                  size="small"
                  color="grey"
                />
                <span
                  className={styles.relation}
                  data-testid="backLinkName"
                >
                  {relationType === EntityRelationType.asymmetric
                    ? backlink
                    : relation}
                  :
                </span>
                <span className={styles.subname}>
                  <Icon
                    name={ICONS.resource.primary as SemanticICONS}
                    size="small"
                  />
                  {displayNameA}
                </span>
              </Flex>
            )}
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
};
